var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C10.866 0 14 3.13396 14 7C14 10.866 10.866 14 7 14C3.13428 14 0.000527448 10.8666 0 7.00098H1.21777C1.2183 10.189 3.81183 12.7822 7 12.7822C10.1885 12.7822 12.7822 10.1885 12.7822 7C12.7822 3.8115 10.1885 1.21777 7 1.21777C5.19562 1.21777 3.5845 2.05048 2.52344 3.34961H3.65039V4.65039H0V1H1.30078V2.93555C2.57028 1.15861 4.64964 1.56666e-07 7 0ZM7.65039 6.73047L10.46 9.54004L9.54004 10.46L6.34961 7.26953V3H7.65039V6.73047Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.7f8133bf731622941fddbb2beae132cb.svg";
export { ForwardRef as ReactComponent };